import { useState } from "react";
import { useLocation } from "react-router-dom";
import { signUp } from "./authService";
import useBootstrapCSS from "../../hooks/useBootstrapCSS";
import codLogo from "./CoD-Logo.png";
import "./login.css";

const SignupPassword = () => {
    useBootstrapCSS();
    const location = useLocation();
    const email = location.state?.email || "";

    const [fullName, setFullName] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState({ text: "", type: "" });
    const [passwordError, setPasswordError] = useState("");

    const validatePasswordComplexity = (pwd) => {
        const minLength = 8;
        const uppercaseRegex = /[A-Z]/;
        const lowercaseRegex = /[a-z]/;
        const nonAlphanumericRegex = /[-!"#$%&()*,./:;?@[\]^_`{|}~+<=]/;
        const repeatingCharsRegex = /(.)\1\1/;
        const forbiddenPatterns = /123|pass/i;
        const username = email.split("@")[0];

        if (pwd.length < minLength) {
            setMessage({ text: "Password must be at least 8 characters long.", type: "fail" });
            return false;
        }
        if (!uppercaseRegex.test(pwd)) {
            setMessage({ text: "Password must contain at least one uppercase letter.", type: "fail" });
            return false;
        }
        if (!lowercaseRegex.test(pwd)) {
            setMessage({ text: "Password must contain at least one lowercase letter.", type: "fail" });
            return false;
        }
        if (!nonAlphanumericRegex.test(pwd)) {
            setMessage({ text: "Password must contain at least one non-alphanumeric character.", type: "fail" });
            return false;
        }
        if (repeatingCharsRegex.test(pwd)) {
            setMessage({ text: "Password must not contain three repeating characters.", type: "fail" });
            return false;
        }
        if (username && pwd.toLowerCase().includes(username.toLowerCase())) {
            setMessage({ text: "Password must not contain the username.", type: "fail" });
            return false;
        }
        if (forbiddenPatterns.test(pwd)) {
            setMessage({ text: "Password must not contain '123' or the word 'pass'.", type: "fail" });
            return false;
        }

        return true;
    };

    const validatePasswordMatch = () => {
        if (password !== confirmPassword) {
            setPasswordError("Passwords do not match.");
            return false;
        }
        setPasswordError("");
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ text: "", type: "" });
        setPasswordError("");

        if (!validatePasswordComplexity(password)) return;
        if (!validatePasswordMatch()) return;

        try {
            const result = await signUp(email, password, fullName);
            if (result.success) {
                setMessage({ text: "Verification Email sent to your mail", type: "success" });
                setTimeout(() => {
                    window.location.href = "/login";
                }, 5000);
            }
        } catch (error) {
            setMessage({ text: error.message || "An unknown error occurred", type: "fail" });
        }
    };

    return (
        <section className="login-page">
            <div className="container-fluid">
                <div className="row align-items-center h-100">
                    <div className="col-md-6 col-sm-12 px-5 left-graphic">
                        <img src={codLogo} className="img-fluid" alt="CoD Logo" />
                    </div>

                    <div className="col-md-6 col-sm-12 px-5 form-outer h-100 align-items-center d-flex justify-content-center">
                        <form className="initial-form" onSubmit={handleSubmit}>
                            <h3 className="h3 mb-4">Create Account</h3>

                            <div className="form-group mb-20">
                                <label htmlFor="loginName">Full Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="loginName"
                                    placeholder="Full Name"
                                    value={fullName}
                                    onChange={(e) => setFullName(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="form-group mb-20">
                                <label htmlFor="loginEmail">{email}</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="loginEmail"
                                    value={email}
                                    readOnly
                                    required
                                />
                            </div>

                            <div className="form-group mb-20">
                                <label htmlFor="loginPassword">Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="loginPassword"
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>

                            <div id="signup-pass" className="form-group mb-20">
                                <label htmlFor="loginConfirmPassword">Confirm Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="loginConfirmPassword"
                                    placeholder="Confirm Password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                            </div>

                            {passwordError && (
                                <div className="bg-danger text-white error_msg">
                                    {passwordError}
                                </div>
                            )}

                            {message.text && (
                                <div className={`p-2 ${message.type === "success" ? "successmessage" : "failmessage"}`}>
                                    {message.text}
                                </div>
                            )}

                            <div className="w-100 d-inine">
                                <button type="submit" className="btn btn-primary mb-20">
                                    Sign Up
                                </button>
                            </div>
                        </form>
                        <div className="form-footer">
                            <div className="d-flex justify-content-center">
                                <p className="text-muted">
                                    Already have an account?{" "}
                                    <a href="/login">Login here</a>
                                </p>
                            </div>
                            <p>Copyright &copy; {new Date().getFullYear()} Compliance on Demand. All Rights Are Reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SignupPassword;
